import { InstallationOfferType } from '@jbhi-fi/components/src/PdpProductProvider/types';
import React from 'react';

import { styles } from './InstallationOffer.css';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { InstallToolsIllustrated } from '@jbhi-fi/lanyard-ui/components/Icons';

import { SupportBlock } from '../supportBlock/SupportBlock';

export type InstallationOfferProps = {
  messages: Array<InstallationOfferType>;
  shouldShowSalesLineNumber?: boolean;
  isJbSalesLineEnabled?: boolean;
};

export const InstallationOffer = ({
  messages,
  shouldShowSalesLineNumber = false,
  isJbSalesLineEnabled = false,
}: InstallationOfferProps) => {
  const dataTestIdPrefix = 'pdp-installation-';

  return (
    <>
      {messages.map((message: InstallationOfferType, index: number) => {
        const { heading = '', shortDescription = '' } = message;
        return (
          <div data-testid={`${dataTestIdPrefix}block`} key={index}>
            <div className={styles.headingContainer} data-testid={`${dataTestIdPrefix}heading-container`}>
              <div className={styles.icon} data-testid={`${dataTestIdPrefix}icon`}>
                <InstallToolsIllustrated />
              </div>
              <CalloutFont as="h3" testId={`${dataTestIdPrefix}header`} className={styles.heading}>
                {heading}
              </CalloutFont>
            </div>
            {shortDescription ? (
              <div data-testid={`${dataTestIdPrefix}detail`}>
                <span dangerouslySetInnerHTML={{ __html: shortDescription }} />
              </div>
            ) : null}
            {isJbSalesLineEnabled ? (
              <div className={styles.contactSection}>
                <SupportBlock
                  shouldShowSalesLineNumber={shouldShowSalesLineNumber}
                  supportContactProps={{ variant: 'inBlock' }}
                  isInstallationOffer={true}
                />
              </div>
            ) : null}
          </div>
        );
      })}
    </>
  );
};
